/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonCompanyPositionInfo,
    JsonCompanyPositionInfoFromJSON,
    JsonCompanyPositionInfoFromJSONTyped,
    JsonCompanyPositionInfoToJSON,
} from './JsonCompanyPositionInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonCompanyPositionInfo
 */
export interface ApiResultOfJsonCompanyPositionInfo {
    /**
     * 
     * @type {JsonCompanyPositionInfo}
     * @memberof ApiResultOfJsonCompanyPositionInfo
     */
    data?: JsonCompanyPositionInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanyPositionInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonCompanyPositionInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanyPositionInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanyPositionInfo
     */
    result?: ApiResultOfJsonCompanyPositionInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonCompanyPositionInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonCompanyPositionInfoFromJSON(json: any): ApiResultOfJsonCompanyPositionInfo {
    return ApiResultOfJsonCompanyPositionInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonCompanyPositionInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonCompanyPositionInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonCompanyPositionInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonCompanyPositionInfoToJSON(value?: ApiResultOfJsonCompanyPositionInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonCompanyPositionInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

